/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  UpdateStatusForResource,
  useGetResourceUpdateStatusQuery,
} from "~/generated/graphql";

type Props = {
  resourceIds: string[];
  skip?: boolean;
};

export function useGetResourceUpdateStatus({ resourceIds, skip }: Props) {
  const { data, loading, error, refetch } = useGetResourceUpdateStatusQuery({
    variables: { resourceIds },
    skip: skip || resourceIds.length === 0,
  });

  return {
    data: (data?.updateStatusForResources ?? []) as UpdateStatusForResource[],
    loading,
    error,
    refetch,
  } as const;
}
